import CashAccountMachineRecordDetailsBase from './base/CashAccountMachineRecordDetailsBase';

/**
 * @class CashAccountMachineRecordDetails
 * @extends CashAccountMachineRecordDetailsBase
 */
class CashAccountMachineRecordDetails extends CashAccountMachineRecordDetailsBase {

}

export default CashAccountMachineRecordDetails;
